<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
            v-if="loaded"
        >
            <rkm-area
                type="fieldset"
                title="Exportar"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.mesesAno"
                            label="Competência"
                            show-default-option
                            text-field="text"
                            v-model="model.mesAno"
                            value-field='value'
                            :validations="validations.mesAno"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="download"
                        >
                            Exportar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Arquivos exportados"
                show-legend
            >

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.mesesAno"
                            label="Competência"
                            text-field="text"
                            v-model="buscaMesAno"
                            value-field='value'
                            :validations="validations.mesAno"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="exportacoes"
                        >
                            Buscar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

                <rkm-table
                    :fields="fields"
                    :items="items"
                    sort-by="data"
                    ref="Table"
                >

                    <template v-slot:cell(data)="{ item }">
                        {{ item.data }} às {{ item.horario }}
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            @click="$refs.Modal.open(item)"
                            title="Registros"
                            color="primary"
                            small
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-area>
        </rkm-form>

        <Modal
            ref="Modal"
            :model="model"
            :form="form"
        />
    </div>
</template>

<script>

import Modal from '@/components/atencao-basica/exportacao/Modal'

// Mixins
import { repository, stringCase, data, object, formats, error } from "@/mixins";

// Vuex.
import { mapActions } from "vuex";

export default {
    components: {
        Modal
    },
    computed: {
        validations() {
            return {
                mesAno: { required: true },
            }
        },
        items() {
            return this.form.exportacao ?? []
        }
    },
    created() {

        this.repositories = {
            exportacao: this.getConectaSusRepository('atencaoBasica.exportacao')
        }

        this.load()
    },
    data: () => ({
        form: {},
        model: {},
        buscaMesAno: null,
        loaded: false,
        fields: [
            {
                key: 'data',
                label: 'Data da exportação',
                sortable: true,
                searchable: true,
            },
            {
                key: 'usuario',
                label: 'Profissional da exportação',
                sortable: true,
                searchable: true,
            },
            {
                key: 'uuid',
                label: 'UUID',
                sortable: true,
                searchable: true,
            },
            {
                key: 'funcionalidade',
                label: 'Funcionalidade',
                sortable: true,
                searchable: true,
            },
            {
                key: 'quantidade',
                label: 'Quantidade de registro(s)',
                sortable: true,
                searchable: true,
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

                this.repositories.exportacao.create()
                    .then(response => {

                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)
                        this.buscaMesAno = response.data.form.mesAno
                        this.loaded = true
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
        download() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        this.setLoading()

                        this.repositories.exportacao.download(this.prepareData())
                            .then(response => {

                                if (response.headers['content-disposition']) {

                                    let file = response.headers['content-disposition'].split('filename=')[1]
                                    file = file.replace('_inconsistente', '');

                                    const blob = new Blob([response.data], {type: response.headers['content-type']})
                                    const link = document.createElement('a')
                                    link.href = URL.createObjectURL(blob)
                                    link.download = file
                                    link.click()
                                    this.$nextTick().then(() => this.exportWithFile())
                                } else {

                                    this.$nextTick().then(() => this.exportWithoutFile())
                                }
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading());
                })
        },
        exportacoes() {

            this.setLoading()

            this.repositories.exportacao.getExportacoes(this.prepareDataBusca())
                .then(({ data }) => {

                    this.form.exportacao = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        exportWithFile() {

            this.showSaveNotification('Exportação realizada com sucesso!')
        },
        exportWithoutFile() {

            this.showAlert('Não há nenhuma ficha disponível para ser exportada.', 'Atenção')
        },
        prepareData() {

            const mesAno = this.model.mesAno

            return this.camelObjectKeysToSnakeRecursive({
                mesAno
            })
        },
        prepareDataBusca() {

            const mesAno = this.buscaMesAno

            return this.camelObjectKeysToSnakeRecursive({
                mesAno
            })
        },
    },
    mixins: [repository, stringCase, data, object, formats, error],
    props: {
        id: { type: [Number, String], default: null },
    }
}
</script>